import React from 'react';
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "oidc-react";
import Button from "../button/Button";
import BackButton from "../button/BackButton";
import { ButtonClass } from "../enums/ButtonClass";
import { AuthCookies } from "../enums/AuthCookies";
import { BenefitType } from "../enums/BenefitType";
import { Party } from "../enums/Party";

const LoginChoice = () => {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const auth = useAuth();
    const benefitType = params?.coverage as BenefitType;
    const party = params?.party as Party;
    const selectedRolePath = `/${benefitType}/${party}`;
    const verifyEmailPath = `/${benefitType}/${party}/verify-email`;
    const returnLocation = (location.state as { from?: { pathname?: string; search?: string } } | null)?.from;
    const returnPath = returnLocation?.pathname
        ? `${returnLocation.pathname}${returnLocation.search ?? ''}`
        : selectedRolePath;

    if (auth?.userData) {
        return <Navigate to={returnPath} replace />;
    }

    return (
        <div className="pds-u-padding-top-40 pds-u-padding-bottom-40">
            <div className="pds-u-padding-bottom-40">
                <h2>Log in or continue as a guest</h2>
                <div>Already have an account? Logging in pre-populates your form fields with your information.</div>
            </div>
            <div className="pds-u-padding-bottom-40" style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
                <div className="pds-u-padding-bottom-12">
                    <Button mainButtonClass={ButtonClass.PRIMARY} onClick={handleLogin}
                        buttonContent={<div style={{ width: "180px" }}>Log In</div>} />
                </div>
                <Button mainButtonClass={ButtonClass.PRIMARY} onClick={handleContinueAsGuest}
                    buttonContent={<div style={{ width: "180px" }}>Continue as a guest</div>} />
            </div>
            <BackButton onClick={() => navigate(`/${benefitType}`)} />
        </div>
    )

    function handleLogin() {
        const redirectUri = returnLocation?.pathname
            ? `${window.location.origin}/#${returnPath}`
            : window.location.href;
        sessionStorage.setItem(AuthCookies.REDIRECT_URI, redirectUri)
        auth.signIn();
    }

    function handleContinueAsGuest() {
        if (returnLocation) {
            navigate(verifyEmailPath, { state: { from: returnLocation } });
            return;
        }
        navigate(verifyEmailPath);
    }
};
export default LoginChoice;